<template>
  <div id="home">
    <section class="search">
      <div class="search-form-container">
        <div class="mx-auto">
          <h1>
            <span class="title">{{ $t('title') }}</span> <br >
            {{ $t('baseline') }}
          </h1>
          <form @submit.prevent="submit">
            <template v-if="schema.fields.length > 0">
              <vue-form-generator
                :schema="schema"
                :model="model"
                :options="{ validationAfterLoad: true, validationAfterChanged: true }"
                :class="search-form"
              />
              <b-row>
                <b-col>
                  <b-button
                    block
                    type="submit"
                    variant="primary"
                  >
                    {{ $t('actions.search') }}
                  </b-button>
                </b-col>
              </b-row>
            </template>
            <div v-else class="text-center">
              <i class="ti ti-2x ti-spin ti-refresh" />
            </div>
          </form>
        </div>
      </div>
      <a
        v-scroll-to="scrollTo"
        class="go-bottom"
        href="#"
      >
        <i class="ti ti-arrow-bottom ti-3x" />
      </a>
    </section>
    <section id="explain" class="explain">
      <b-container>
        <div class="intro">
          <h2>{{ $t('pages.home.how_to.title') }}</h2>
          <p v-html="$t('pages.home.how_to.text')" />
        </div>
      </b-container>
      <image-block
        v-for="explain in explainProcess"
        :key="explain.title"
        :image-url="explain.imageUrl"
        :image-on-right="explain.imageOnRight"
        :title="explain.title"
        :text="explain.text"
      />
      <e-jumbotron :data="jumbotron">
        <b-button variant="primary" @click="openModal('sign-in-sign-up-modal', 'sign-up')">
          {{ jumbotron.btnText }}
        </b-button>
      </e-jumbotron>
    </section>
  </div>
</template>

<script>
  import VueFormGenerator from '@triotech/vue-core/src/vendor/vue-form-generator';
  import ImageBlock from '@/components/ImageBlock';
  import EJumbotron from '@/components/EJumbotron';

  export default {
    name: 'HomePage',
    components: {
      'vue-form-generator': VueFormGenerator.component,
      ImageBlock,
      EJumbotron,
    },
    data() {
      return {
        scrollTo: {
          el: '#explain',
          offset: -60,
        },
        explainProcess: [{
          imageUrl: '../../../static/img/tmp.jpg',
          imageOnRight: false,
          title: this.$t('pages.home.create.title'),
          text: this.$t('pages.home.create.text'),
        }, {
          imageUrl: '../../../static/img/home-02.jpg',
          imageOnRight: true,
          title: this.$t('pages.home.comunicate.title'),
          text: this.$t('pages.home.comunicate.text'),
        }, {
          imageUrl: '../../../static/img/home-03.jpg',
          imageOnRight: false,
          title: this.$t('pages.home.share.title'),
          text: this.$t('pages.home.share.text'),
        }],
        jumbotron: {
          bg: '../../../static/img/home-04.jpg',
          title: this.$t('pages.home.jumbotron.title'),
          btnText: this.$t('actions.start'),
        },
        search: null,
        form: null,
        model: {},
        schema: {
          fields: [],
        },
      };
    },
    async mounted() {
      await this.$ajax.get('api/public/search/_form')
        .then((data) => {
          this.$set(this.schema, 'fields', _.form(this.$t, data));
        });
    },
    methods: {
      openModal(id, data = null) {
        this.$bus.$emit(`t-event.t-modal.${id}.open`, data);
      },
      async submit() {
        if (this.model.search === undefined) {
          this.$notify({
            title: this.$t('flashes.search.empty'),
            text: this.$t('flashes.search.empty_text'),
          });
        } else {
          await this.$ajax.get(`api/public/search/?search=${this.model.search}`)
            .then((res) => {
              this.forward(res);
            });
        }
      },
      forward(result) {
        if (result.length === 0) {
          this.$notify({
            title: this.$t('flashes.search.no_result'),
            text: `${this.$t('flashes.search.no_result_for')}: ${this.model.search}`,
            type: 'warning',
          });
        } else if (result.length > 0) {
          this.$router.push({ name: 'memorial.index', params: { search: this.model.search } });
        } else {
          this.$router.push({ name: 'memorial.show', params: { id: result[0].unique_key } });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  #home {
    .search {
      min-height: calc(100vh - #{$nav-height});
      margin: 0 -15px;
      position: relative;
      background: {
        image: url('../../../static/img/accueil.jpg');
        position: center;
        repeat: no-repeat;
        size: cover;
      };

      .go-bottom {
        color: $white;
        position: absolute;
        bottom: 76px;
        left: 0;
        right: 0;
        text-align: center;

        &:hover {
          text-decoration: none;
        }
      }

      .search-form-container {
        display: flex;
        align-items: center;
        flex-direction: row;
        height: calc(100vh - #{$nav-height});
        padding: 0 8rem;

        h1 {
          color: $white;

          .title {
            color: $primary;
            font-size: 3rem;
          }
        }

        /deep/ input {
          height: $input-height;
        }
      }
    }

    .explain {
      margin-top: 2rem;

      .intro {
        margin: 5rem 0;
      }
    }
  }

  @include editable-max-width(575px) {
    #home {
      .search {
        .search-form-container {
          padding: 0 1rem;

          h1 {
            font-size: 1.5rem;
          }
        }
      }
    }
  }

  @include editable-max-height(620px) {
    #home {
      .search {
        .go-bottom {
          bottom: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Default/Home.vue